import { GET_ALLERGENS } from "./AllergenAction";

export const AllergenReducer = (state, action) => {
  switch (action.type) {
    case GET_ALLERGENS:
      return {
        ...state,
        allergens: action.payload,
      };

    default:
      return state;
  }
};

export default AllergenReducer;
